import { useState, useEffect } from "react";
import { Phone, MessageCircle, ArrowUp, ArrowUpRight, ShieldCheck, Clock, Lock, Star } from "lucide-react";
import { Link } from "@/components/common/Link";
const NAVY = "#081438";
const NAVY_LIGHT = "#243752";
const NAVY_DEEP = "#040A1F";
const GOLD = "#F5A623";
const FONT_HEAD = "'Plus Jakarta Sans', system-ui, sans-serif";
const FONT_BODY = "'Manrope', system-ui, sans-serif";
const FONT_MONO = "ui-monospace, 'SF Mono', 'JetBrains Mono', Menlo, monospace";
const TRUST_ITEMS = [{
  icon: Clock,
  label: "Same-Day Repair"
}, {
  icon: Lock,
  label: "Fixed-Price Quote"
}, {
  icon: ShieldCheck,
  label: "12-Mo Warranty"
}, {
  icon: Star,
  label: "5.0 Rated"
}];
const BRANDS = [{
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/b5706f1be_58dae4e4d_BD_Australia_Logo.webp",
  alt: "B&D Australia"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/24bd15fa9_a095621ff_Merlin-Logo-Positive.webp",
  alt: "Merlin"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/7656bc9c2_c348bc03e_gliderol-logo.webp",
  alt: "Gliderol"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/liftmaster.webp",
  alt: "LiftMaster"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/steel-line-garage-doors.webp",
  alt: "Steel-Line"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/marantec.webp",
  alt: "Marantec"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/doors-industrial.webp",
  alt: "4D Industrial"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/grifco.png",
  alt: "Grifco"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/ata-logo-min-300x226.png.webp",
  alt: "ATA"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/5e385702d_6c94e3d82_superliftlogo-1.png",
  alt: "Superlift"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/centurion-garage-doors.webp",
  alt: "Centurion"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/hormann.webp",
  alt: "Hörmann"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/boss-forza-logo.png",
  alt: "BOSS Forza"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/dea-system-logo.png",
  alt: "DEA Gate Automation"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/faac-logo.png",
  alt: "FAAC"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/auto-openers-logo.png",
  alt: "Auto Openers"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/doorworks-logo.png",
  alt: "DoorWorks"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/sommer-logo.png",
  alt: "Sommer"
}, {
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1681701/img/genie-logo.png",
  alt: "Genie"
}];
export default function MotorFinalCta() {
  return <section className="relative overflow-hidden" style={{
    backgroundColor: NAVY,
    fontFamily: FONT_BODY
  }} aria-labelledby="motor-final-cta-heading">
      <div aria-hidden className="absolute inset-0 pointer-events-none" style={{
      background: `radial-gradient(ellipse at 30% 20%, ${NAVY_LIGHT}80 0%, transparent 50%), radial-gradient(ellipse at 80% 90%, ${NAVY_DEEP} 0%, transparent 60%), radial-gradient(circle at 50% 50%, ${GOLD}0A 0%, transparent 70%)`
    }} />
 
      <div aria-hidden className="absolute inset-0 opacity-[0.06] mix-blend-overlay pointer-events-none" style={{
      backgroundImage: "url(\"data:image/svg+xml;utf8,<svg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2' stitchTiles='stitch'/><feColorMatrix values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0'/></filter><rect width='100%' height='100%' filter='url(%23n)'/></svg>\")"
    }} />
 
      <div aria-hidden className="absolute top-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent 0%, ${GOLD}66 50%, transparent 100%)`
    }} />
 
      <div aria-hidden className="absolute -top-32 -right-32 pointer-events-none opacity-30">
        <div className="w-[400px] h-[400px] rounded-full border" style={{
        borderColor: `${GOLD}20`
      }}>
          <div className="absolute inset-8 rounded-full border" style={{
          borderColor: `${GOLD}20`
        }}>
            <div className="absolute inset-8 rounded-full border" style={{
            borderColor: `${GOLD}20`
          }} />
          </div>
        </div>
      </div>
 
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10 pt-24 md:pt-32 pb-20 md:pb-24">
 
        <div className="flex items-center justify-between gap-6 mb-16 md:mb-20 flex-wrap">
          <div className="inline-flex items-center gap-3 rounded-full border px-4 py-2" style={{
          borderColor: `${GOLD}40`,
          backgroundColor: `${GOLD}0F`
        }}>
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full opacity-75" style={{
              backgroundColor: GOLD
            }} />
              <span className="relative inline-flex h-2 w-2 rounded-full" style={{
              backgroundColor: GOLD
            }} />
            </span>
            <span className="text-[11px] font-bold tracking-[0.22em] uppercase" style={{
            color: GOLD,
            fontFamily: FONT_BODY
          }}>
              Answering Motor Calls · Now
            </span>
          </div>
 
          <div className="inline-flex items-center gap-2 text-[10px] font-bold tracking-[0.22em] uppercase" style={{
          color: "rgba(255,255,255,0.45)",
          fontFamily: FONT_MONO
        }}>
            <span style={{
            color: GOLD
          }}>·</span>
            Sydney · Live
          </div>
        </div>
 
        <div className="max-w-5xl">
          <h2 id="motor-final-cta-heading" className="font-extrabold text-white mb-6 md:mb-8" style={{
          fontFamily: FONT_HEAD,
          fontSize: "clamp(2.25rem, 7.5vw, 6rem)",
          lineHeight: 0.96,
          letterSpacing: "-0.04em"
        }}>
            Tonight, your garage door
            <br />
            opens like{" "}
            <span className="relative inline-block">
              <span style={{
              color: GOLD
            }}>new again.</span>
              <span aria-hidden className="absolute left-0 right-0 -bottom-2 md:-bottom-3 h-[3px] md:h-[5px]" style={{
              background: `linear-gradient(90deg, ${GOLD} 0%, ${GOLD}00 100%)`,
              borderRadius: "2px"
            }} />
            </span>
          </h2>
 
          <p className="max-w-2xl text-[16px] md:text-lg leading-relaxed mb-10 md:mb-12" style={{
          color: "rgba(255,255,255,0.75)"
        }}>
            One call, one phone diagnosis, one same-day visit. No call-out fee
            to look. No commission-driven techs. No pressure scripts.{" "}
            <span className="text-white font-semibold">
              Just an honest fix from the family Sydney has trusted since 2009.
            </span>
          </p>
 
          <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 mb-12">
            <a href="tel:0485000933" aria-label="Call Gold Garage Door on 0485 000 933" className="group inline-flex items-center justify-center gap-3 rounded-full px-7 md:px-9 py-4 md:py-5 text-[15px] md:text-base font-bold transition-all duration-200 hover:scale-[1.03] active:scale-[0.98]" style={{
            backgroundColor: GOLD,
            color: NAVY,
            fontFamily: FONT_BODY,
            boxShadow: `0 20px 50px -12px ${GOLD}99`
          }}>
              <Phone className="h-5 w-5" strokeWidth={2.5} />
              Call 0485 000 933 Now
              <ArrowUpRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" strokeWidth={2.5} />
            </a>
 
            <a href="https://wa.me/61485000933" className="group inline-flex items-center justify-center gap-2.5 rounded-full border-2 px-7 py-4 text-[15px] font-semibold text-white transition-all duration-200" style={{
            borderColor: "rgba(255,255,255,0.30)",
            fontFamily: FONT_BODY
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = "rgba(255,255,255,0.10)";
            e.currentTarget.style.borderColor = "rgba(255,255,255,0.55)";
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = "transparent";
            e.currentTarget.style.borderColor = "rgba(255,255,255,0.30)";
          }}>
              <MessageCircle className="h-5 w-5" strokeWidth={2} />
              WhatsApp Us
            </a>
          </div>
 
          <a href="#contact-us" className="group inline-flex items-center gap-3 text-[13px] font-bold tracking-[0.16em] uppercase transition-colors" style={{
          color: "rgba(255,255,255,0.55)",
          fontFamily: FONT_BODY
        }} onMouseEnter={e => e.currentTarget.style.color = GOLD} onMouseLeave={e => e.currentTarget.style.color = "rgba(255,255,255,0.55)"}>
            <span className="inline-flex items-center justify-center w-8 h-8 rounded-full border transition-all duration-300 group-hover:-translate-y-0.5" style={{
            borderColor: "rgba(255,255,255,0.20)",
            backgroundColor: "rgba(255,255,255,0.04)"
          }}>
              <ArrowUp className="h-4 w-4" strokeWidth={2.5} />
            </span>
            Or scroll up to the free quote form
          </a>
        </div>
      </div>
 
      {/* === BRAND MARQUEE === */}
      <div className="relative mt-16 md:mt-20 pt-10 pb-2 border-t" style={{
      borderColor: "rgba(255,255,255,0.10)"
    }}>
        <div className="mx-auto max-w-7xl px-6 lg:px-10">
          <div className="flex items-center justify-center gap-3 mb-7">
            <span className="inline-flex items-center justify-center px-2.5 py-1 rounded-lg text-[12px] font-bold border leading-none" style={{
            color: GOLD,
            background: `linear-gradient(135deg, ${GOLD}33 0%, ${GOLD}0D 100%)`,
            borderColor: `${GOLD}40`,
            fontFamily: FONT_HEAD
          }}>20+</span>
            <span className="text-[12px] md:text-[13px] font-bold tracking-[0.22em] uppercase" style={{
            color: GOLD,
            fontFamily: FONT_BODY
          }}>
              Australian &amp; International Brands Serviced
            </span>
          </div>
        </div>
 
        {/* Edge gradients in navy */}
        <div aria-hidden className="absolute left-0 top-0 bottom-0 w-16 md:w-24 z-10 pointer-events-none" style={{
        background: `linear-gradient(to right, ${NAVY}, transparent)`
      }} />
        <div aria-hidden className="absolute right-0 top-0 bottom-0 w-16 md:w-24 z-10 pointer-events-none" style={{
        background: `linear-gradient(to left, ${NAVY}, transparent)`
      }} />
 
        <div className="relative overflow-hidden group">
          <div className="flex items-center w-max group-hover:[animation-play-state:paused] py-4" style={{
          animation: "motorMarqueeScroll 50s linear infinite"
        }}>
            {[...BRANDS, ...BRANDS].map((brand, i) => <img key={i} src={brand.src} alt={brand.alt} title={brand.alt} width="120" height="40" loading="lazy" decoding="async" className="h-7 md:h-9 w-auto object-contain px-5 md:px-8 shrink-0 transition-all duration-400 cursor-default select-none" style={{
            filter: "brightness(0) invert(1)",
            opacity: 0.45
          }} onMouseEnter={e => {
            e.currentTarget.style.opacity = "0.95";
            e.currentTarget.style.transform = "scale(1.08)";
          }} onMouseLeave={e => {
            e.currentTarget.style.opacity = "0.45";
            e.currentTarget.style.transform = "scale(1)";
          }} />)}
          </div>
        </div>
 
        <style>{`
          @keyframes motorMarqueeScroll {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }
        `}</style>
      </div>
 
      <div className="relative mx-auto max-w-7xl px-6 lg:px-10 pb-20 md:pb-24">
        <div className="mt-12 md:mt-14 pt-10 border-t flex flex-col md:flex-row items-start md:items-center justify-between gap-8 md:gap-10" style={{
        borderColor: "rgba(255,255,255,0.10)"
      }}>
          <ul className="grid grid-cols-2 sm:grid-cols-4 gap-x-6 gap-y-4 flex-1">
            {TRUST_ITEMS.map(({
            icon: Icon,
            label
          }) => <li key={label} className="flex items-center gap-2.5">
                <span className="flex-shrink-0 inline-flex items-center justify-center w-9 h-9 rounded-xl border" style={{
              borderColor: `${GOLD}33`,
              backgroundColor: `${GOLD}0F`
            }}>
                  <Icon className="h-[15px] w-[15px]" strokeWidth={2} style={{
                color: GOLD
              } as React.CSSProperties} />
                </span>
                <span className="text-[12px] font-bold tracking-[0.08em] uppercase" style={{
              color: "rgba(255,255,255,0.85)",
              fontFamily: FONT_BODY
            }}>
                  {label}
                </span>
              </li>)}
          </ul>
 
          <div className="flex items-center gap-4 flex-shrink-0">
            <div className="flex items-center justify-center w-12 h-12 rounded-full font-extrabold text-sm flex-shrink-0" style={{
            backgroundColor: GOLD,
            color: NAVY,
            fontFamily: FONT_HEAD,
            letterSpacing: "-0.02em"
          }}>
              GG
            </div>
            <div>
              <div className="text-[13px] font-bold text-white" style={{
              fontFamily: FONT_HEAD,
              letterSpacing: "-0.01em"
            }}>
                Gold Garage Door
              </div>
              <div className="text-[10px] font-semibold tracking-[0.18em] uppercase mt-0.5" style={{
              color: "rgba(255,255,255,0.5)"
            }}>
                Bass Hill · Sydney NSW · Est. 2009
              </div>
            </div>
          </div>
        </div>
      </div>
 
      <div aria-hidden className="absolute bottom-0 left-0 right-0 h-px" style={{
      background: `linear-gradient(90deg, transparent 0%, ${GOLD}66 50%, transparent 100%)`
    }} />
    </section>;
}